/// <amd-module name="Wiki/PageTree/Components/TreeMoreColumn" />
import { IMenuProps } from "VSSUI/Menu";
import { ColumnMore } from "VSSUI/Table";
import { ITreeItemEx } from "VSSUI/Utilities/TreeItemProvider";
import { WikiPage } from "Wiki/Clients/Wiki/Contracts/Wiki";
import { WikiTreePage } from "Wiki/PageTree/Contracts";

export class TreeMoreColumn extends ColumnMore<ITreeItemEx<WikiTreePage>> {
    constructor(menuProvider: (item: WikiPage) => IMenuProps, menuAvailable: (page: WikiPage) => boolean) {
        super(
            (item: ITreeItemEx<WikiTreePage>): IMenuProps => {
                return menuProvider(item.underlyingItem.data);
            },
            (item: ITreeItemEx<WikiTreePage>): boolean => {
                return menuAvailable(item.underlyingItem.data);
            }
        );
    }
}
